import { render, staticRenderFns } from "./SingleFloor.vue?vue&type=template&id=063235ba&"
import script from "./SingleFloor.vue?vue&type=script&lang=js&"
export * from "./SingleFloor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports